<template>
  <div>
    <PageTitleVue
      :sub-title="'Faça a gestão dos seus lutadores'"
    >
      LUTADORES
      <!-- <template #b-action>
        <Create
          @click="router.push('/fighters/new')"
          :icon="UserPlusIcon"
          :label="'Adicionar'"
          :menu-active="'Lutadores'"
        />
      </template> -->

    </PageTitleVue>

    <section>
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">

        <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
          <SearchInput v-model="searchTerm" />
        </div>

        <DataTable :data="filteredData">
          <template #head>
            <th scope="col" class="px-6 py-3">Nome</th>
            <th scope="col" class="px-6 py-3">Contatos</th>
            <th scope="col" class="px-6 py-3">Participações em eventos</th>
            <th scope="col" class="px-6 py-3 text-center">#</th>
          </template>
        </DataTable>
      </div>
    </section>

  </div>
</template>

<script setup>
import SearchInput from '@/components/Tables/SearchInput.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CollabService from './services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import DataTable from './components/DataTable.vue'
import router from '@/router'
import { storeApp } from '@/store'
import { onBeforeMount, ref, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'

import { UserPlusIcon } from '@heroicons/vue/24/outline'
import { dataFighters } from './store'

const appStore = storeApp.state
const dataTable = computed(() => dataFighters.getters.getFighters)
const searchTerm = ref('')

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable?.value?.filter((row) => {
    const matchesSearch = !searchTerm.value ||
      ['name', 'email', 'phone'].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesSearch
  })
})

onBeforeMount(async () => {
  appStore.loading = true
  await getFighters()
  appStore.loading = false
})

async function getFighters () {
  await CollabService.getFighters()
    .then(res => {
      console.log(res.data)
      dataTable.value = res.data
      dataFighters.dispatch('setFightersCollect', res.data)
    }).catch(err => {
      toast(
        'Erro',
        'Algo deu errado ao buscar lutadores',
        'error'
      )
    })
}

</script>
